import { createClient} from "microcms-js-sdk";

export const plt_microcms = (serviceDomain: string, apiKey: string) => {
  return createClient({
    serviceDomain: serviceDomain,
    apiKey: apiKey,
  });
}